{
  "received_referrals": {
    "grid": {
      "track_referral_header": "Track a Referral",
      "track_received_referral": "Track Received Referral",
      "track_received_referral_aria": "track received referral",
      "export_filename": "received referrals",
      "open_slider_aria": "open slider"
    },
    "create": {
      "track_referral": "TrackReferral"
    },
    "form": {
      "validation": {
        "company_required": "Please enter a company"
      },
      "labels": {
        "client_company": "Client Company (Associated Company) *",
        "client_contact": "Client Contact (Key Contact)",
        "description": "Description",
        "description_placeholder": "Describe your opportunity in one sentence",
        "opportunity_date": "Opportunity Date",
        "date_placeholder": "date",
        "received_by": "Received By (Internal Owner)",
        "received_by_placeholder": "Who will be responsible for this opportunity?",
        "sent_by": "Sent By (Referral Source)",
        "sent_by_placeholder": "Who referred this opportunity?",
        "more_fields": "MORE FIELDS",
        "status": "Status",
        "tags": "Tags",
        "proposed_fee": "Proposed Fee",
        "team_involved": "Team Involved",
        "team_involved_placeholder": "Team involved in this opportunity?",
        "opportunity": "Opportunity",
        "referral": "Referral",
        "company_search_placeholder": "Type to search company"
      }
    },
    "loading": {
      "loading_referrals": "Loading referrals",
      "error_prefix": "Error: ",
      "load_limit_message": "Referral table limited to 10,000 rows. Reach out for additional data."
    }
  },
  "sent_referral_preview": {
    "header": "Sent Referral",
    "sent_on": "Sent on",
    "sent_to": "Sent to",
    "type_of_legal_matter": "Type of Legal Matter",
    "client_contact": "Client Contact",
    "client_company": "Client Company",
    "referred_by_employee": "Referred by Employee",
    "status": "Status"
  },
  "result_status_field": {
    "matter_created": "Matter Created",
    "matter_not_created": "Matter Not Created",
    "matter_pending": "Matter Pending"
  },
  "sent_referral_form": {
    "track_referral": "Track Referral",
    "track_a_referral": "Track a referral",
    "update_referral": "Update referral",
    "date": "Date",
    "to": "To",
    "from": "From",
    "client": "Client",
    "client_contact": "Client contact",
    "client_company_placeholder": "Client company",
    "type_of_legal_matter": "Type of legal matter",
    "did_result_in_matter": "Did this referral result in a matter?",
    "track_referral_button": "Track referral",
    "please_choose_date": "Please choose the date",
    "please_add_contact": "Please add a contact",
    "contact_name_placeholder_from": "Contact Name",
    "client_contact_placeholder": "Contact name",
    "update_sent_referral_aria_label": "update sent referral"
  },
  "delete_sent_referral": {
    "label": "delete sent referral",
    "confirm_title": "Are you sure you want to delete this sent referral?"
  },
  "sent_referrals_list": {
    "error": "Error: {{message}}",
    "load_limit": "Referral table limited to 10,000 rows. Reach out for additional data."
  },
  "sent_referral_grid": {
    "file_name": "sent referrals",
    "audit_primary_name": "sent referral view",
    "audit_secondary_name": "all sent referrals"
  },
  "sent_referral_actions": {
    "open_slider": "open slider"
  },
  "nav": {
    "sent_referrals": "Sent Referrals",
    "received_referrals": "Received Referrals"
  },
  "referral_grid": {
    "columns": {
      "actions": "Actions",
      "date": "Date",
      "sent_to_contact": "Sent To Contact",
      "sent_to_contact_email": "Sent To Contact (Email)",
      "sent_to_contact_country": "Sent To Contact Country",
      "sent_to_contact_city": "Sent To Contact City",
      "sent_to_contact_job_title": "Sent To Contact Job Title",
      "sent_to_company": "Sent To Company",
      "sent_to_company_engagement": "Sent To Company Engagement",
      "sent_to_company_type": "Sent To Company Type",
      "sent_to_company_industry_names": "Sent To Company Industries",
      "sent_to_company_location": "Sent To Company Location",
      "sent_to_company_city": "Sent To Company City",
      "sent_to_company_state": "Sent To Company State",
      "sent_to_company_country": "Sent To Company Country",
      "client_company": "Client Company",
      "client_company_engagement": "Client Company Engagement",
      "client_company_type": "Client Company Type",
      "client_company_industry_names": "Client Company Industries",
      "client_company_location": "Client Company Location",
      "client_company_city": "Client Company City",
      "client_company_state": "Client Company State",
      "client_company_country": "Client Company Country",
      "client_contact": "Client Contact",
      "client_contact_email": "Client Contact (Email)",
      "client_contact_country": "Client Contact Country",
      "client_contact_city": "Client Contact City",
      "client_contact_job_title": "Client Contact Job Title",
      "referred_by_employee": "Referred By Employee",
      "referred_by_employee_email": "Referred By Employee (Email)",
      "referred_by_employee_department": "Referred By Employee Department",
      "referred_by_employee_office": "Referred By Employee Office",
      "status": "Status",
      "company": "Company",
      "title_description": "Title/Description",
      "tracking_number": "Tracking Number",
      "tags": "Tags",
      "company_type": "Company Type",
      "company_industry_names": "Company Industries",
      "internal_owner": "Internal Owner",
      "internal_owner_email": "Internal Owner (Email)",
      "team_involved": "Team Involved",
      "team_involved_email": "Team Involved (Email)",
      "internal_owner_department": "Internal Owner Department",
      "internal_owner_office": "Internal Owner Office",
      "key_contact": "Key Contact",
      "key_contact_email": "Key Contact (Email)",
      "key_contact_country": "Key Contact Country",
      "key_contact_city": "Key Contact City",
      "key_contact_job_title": "Key Contact Job Title",
      "fee": "Fee",
      "custom_status": "Status",
      "engagement": "Engagement",
      "referral_source": "Referral Source",
      "referral_source_email": "Referral Source (Email)",
      "referral_source_company": "Referral Source Company",
      "referral_source_country": "Referral Source Country",
      "last_interaction": "Last Interaction"
    }
  }
}
